import { FC } from 'react';
import { Background, defaultShimmerSpeed, StyledSkeleton } from './Skeleton.styled';

type Props = {
  /** whether to show the loading animation or child component */
  isLoading: boolean;
  /** animation speed in milliseconds for the shimmer */
  shimmerSpeed?: number;
};

export const SkeletonContainer: FC<React.PropsWithChildren<Props>> = ({
  children = null,
  isLoading = false,
  shimmerSpeed = defaultShimmerSpeed,
  ...props
}) => (
  <StyledSkeleton data-test="skeleton-wrapper" isLoading={isLoading} {...props}>
    {isLoading ? <Background data-test="skeleton-bg" speed={shimmerSpeed} /> : children}
  </StyledSkeleton>
);
